import { fetchData } from '../utils'
import { ApplicationState } from '../store';
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Table, Button, Select, Tabs, Row, Col, message } from 'antd';
import * as React from "react";
import * as AuthStore from "../store/Auth";

const { Option } = Select;
const { TabPane } = Tabs;

type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class Refill extends React.Component<AuthProps>
{
    public state =
    {
        buttonText: 'Add',
        ref1: [],
        ref2: [],
        ref3: [],
        ref4: [],
        ref5: [],
        ref6: [],
        ref7: [],
        states: [],
        sites: [],
        weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        statesLoaded: false,
        loading: false,
        loadingOth: false,
        confirmLoading: false,
        site: { Id: '', name: '', stateCode: '', lga: '', siteId: '', state: '' },
        state: { id: 0, name: '', code: '', sites: [] },
        searchObj:
        {
            state: '',
            site: 0,
            siteName: '',
            stateName: ''
        }
    };
    ////@ts-ignore
    async componentDidMount()
    {
        let el = this;
        let user = this.props.appUser;

        let sts = localStorage.getItem("states");
        let states = [];
        if (sts) states = JSON.parse(sts);

        let sites = [];
        if (user.stateCode && user.stateCode.length > 0) {
            var statex = states.filter(s => {
                return s.stateCode.toLocaleLowerCase() === user.stateCode.toLocaleLowerCase();
            });
            if (statex.length > 0) {
                let { searchObj } = this.state;
                let state: any = states[0];
                this.setState({ state, searchObj });
            }
        }

        let statesLoaded = true;
        this.setState({ states, statesLoaded });
    }
    
    selectSite(value: any)
    {
        const { searchObj } = this.state;
        if (value) {
            searchObj.site = value.key;
            let sites: any = this.state.sites.filter(function (o: any) { return o.siteId === searchObj.site });
            if (sites.length > 0) searchObj.siteName = sites[0].name;
            this.setState({ searchObj, sites });
        }
    }

    selectState(value: any)
    {
        var el = this;
        if (!value)
        {
            return;
        }
        const { searchObj } = this.state;
        searchObj.site = 0;
        if (value) {
            let val = value.key;
            let states = this.state.states.filter(function (s: any) { return s.stateId === val });
            if (states.length > 0) {
                var state = states[0];
                el.setState({ state: state, searchObj: searchObj });
            }
        }
    }

   ////@ts-ignore
    async getRefill(pointer: number = 1)
    {
        let el = this;
        if (el.state.searchObj.site === null || el.state.searchObj.site < 1)
        {
            message.error("Please select a Facility");
            return;
        }
        this.setState({ loading: true });
        
        var query = `/api/Stats/getDueRefills?site=${el.state.searchObj.site}&pointer=${pointer}`;

        let res = await fetchData(query);    
        
        if (pointer < 7)
        {
            if (pointer === 1)
            {
                el.setState({ ref1: res });
            }

            if (pointer === 2)
            {
                el.setState({ ref2: res, loading: false, loadingOth: false });
            }
            if (pointer === 3)
                el.setState({ ref3: res });
            if (pointer === 4)
                el.setState({ ref4: res });
            if (pointer === 5)
                el.setState({ ref5: res });
            if (pointer === 6)
                el.setState({ ref6: res });
            if (pointer === 7)
                el.setState({ ref7: res });
            
            pointer += 1;
            el.getRefill(pointer)
        }
        else
        {
            el.setState({ ref7: res, loading: false, loadingOth: false });    
        }
    }
         
    render()
    {
        const d = new Date();
        let day1 = d.getDay();

        d.setDate(d.getDate() + 1);
        let day2 = d.getDay();

        const d2 = new Date();
        d2.setDate(d2.getDate() + 2);
        let day3 = d2.getDay();

        const d3 = new Date();
        d3.setDate(d3.getDate() + 3);
        let day4 = d3.getDay();

        const d4 = new Date();
        d4.setDate(d4.getDate() + 4);
        let day5 = d4.getDay();

        const d5 = new Date();
        d5.setDate(d5.getDate() + 5);
        let day6 = d5.getDay();

        const d6 = new Date();
        d6.setDate(d6.getDate() + 6);
        let day7 = d6.getDay();

        const columns =
            [
                {
                    title: 'State',
                    dataIndex: 'stateCode',
                    key: 'stateCode',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Facility',
                    dataIndex: 'facility',
                    key: 'facility',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Patient Id',
                    dataIndex: 'patientId',
                    key: 'patientId',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Hospital Number',
                    dataIndex: 'hospitalNumber',
                    key: 'hospitalNumber',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Sex',
                    dataIndex: 'sex',
                    key: 'sex',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'ART Start Date',
                    dataIndex: 'artStartDate',
                    key: 'artStartDate',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Date Of Birth',
                    dataIndex: 'dateOfBirth',
                    key: 'dateOfBirth',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                { 
                    title: 'Age',
                    dataIndex: 'age',
                    key: 'age',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Current Regimen',
                    dataIndex: 'lastRegimen',
                    key: 'lastRegimen',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Current Regimen Line',
                    dataIndex: 'lastRegimenLine',
                    key: 'lastRegimenLine',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                 {
                     title: 'Current Pickup Date',
                     dataIndex: 'lastDrugPickup',
                     key: 'lastDrugPickup',
                     render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                },
                {
                    title: 'Current Days Of ARV Refill',
                    dataIndex: 'lastDaysOfARVRefill',
                    key: 'lastDaysOfARVRefill',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value ? value : ''}</span>
                }
        ];
     
        const { loading, loadingOth, state, states } = this.state;                      
        let user = this.props.appUser;

        return (
            <div className="site-top">
                <Helmet>
                    <title>CDR - Clients Due For ARV Refill</title>
                </Helmet>
                <div className="custom-filter-dropdown">
                    <br/>
                    <Row style={{ marginTop: '2px' }}>
                        <Col span={24}>
                            <h4 style={{ fontWeight: 'bold', fontSize: '18px' }}>Clients Due For ARV Refill within a week time</h4>
                        </Col>
                        <Col span={24} style={{ marginTop: '5px' }}>
                            <span style={{ fontWeight: 'bold'}}>Starting from today</span>
                        </Col>
                    </Row>
                    <br/>
                    <Row gutter={2}>
                        {!user.stateCode &&
                            <Col xs={24} sm={24} md={8} lg={8}>
                                <Select
                                labelInValue className="top-10-margin"
                                    showSearch
                                    optionFilterProp="children"
                                    disabled={loading}
                                    style={{ width: '98%' }}
                                    placeholder="Select State"
                                    onChange={(value) => this.selectState(value)}
                                >
                                    <Option key="" value="">-- Select State --</Option>
                                {states && states.map((s: any) => <Option key={s.stateId} value={s.stateId}>{s.stateName}</Option>)}
                                </Select>
                            </Col>
                        }
                        <Col xs={24} sm={24} md={8} lg={8}>
                            <Select
                                labelInValue className="top-10-margin"
                                showSearch
                                optionFilterProp="children"
                                disabled={loading}
                                style={{ width: '98%', float: 'right' }}
                                placeholder="Select Facility"
                                onChange={(value) => this.selectSite(value)}
                            >
                                <Option key="" value="">-- Select Facility --</Option>
                                {state.sites && state.sites.map((s: any) => <Option key={s.id} value={s.id}>{s.name}</Option>)}
                            </Select>
                        </Col>
                        <Col xs={24} sm={24} md={4} lg={4}>
                            <Button disabled={loading} className="login-button top-10-margin" id="push-btn" loading={loading || loadingOth} key="submit" type="primary" size="large" onClick={() => this.getRefill(1)} style={{ paddingRight: '40px', paddingLeft: '40px', float: 'right', width: '100%' }}>
                                <span id="buttonText">{!(loading && loadingOth) ? 'Fetch Data' : 'Processing...'}</span>
                            </Button>
                        </Col>
                    </Row>
                    <br />                    
                    <Row>
                        <Col span={24} className="ant-modal-footer si-ant">
                            <Tabs defaultActiveKey="1">
                                <TabPane tab={this.state.weekdays[day1]} key="1">
                                    <Row>
                                        <Col span={24} style={{ overflow: "scroll" }}>
                                            <Table columns={columns} rowKey={(record: any) => record.patientId} dataSource={this.state.ref1} loading={loading} bordered />
                                        </Col>
                                    </Row>                                      
                                </TabPane>
                                <TabPane tab={this.state.weekdays[day2]} key="2">
                                    <Row>
                                        <Col span={24} style={{ overflow: "scroll" }}>
                                            <Table columns={columns} rowKey={(record: any) => record.patientId} dataSource={this.state.ref2} loading={loading} bordered />
                                        </Col>
                                    </Row>                                     
                                </TabPane>
                                <TabPane tab={this.state.weekdays[day3]} key="3">
                                    <Row>
                                        <Col span={24} style={{ overflow: "scroll" }}>
                                            <Table columns={columns} rowKey={(record: any) => record.patientId} dataSource={this.state.ref3} loading={loadingOth} bordered />
                                        </Col>
                                    </Row>                                      
                                </TabPane>
                                <TabPane tab={this.state.weekdays[day4]} key="4">
                                    <Row>
                                        <Col span={24} style={{ overflow: "scroll" }}>
                                            <Table columns={columns} rowKey={(record: any) => record.patientId} dataSource={this.state.ref4} loading={loadingOth} bordered />
                                        </Col>
                                    </Row>                                     
                                </TabPane>
                                <TabPane tab={this.state.weekdays[day5]} key="5">
                                    <Row gutter={2}>
                                        <Col span={24} style={{ overflow: "scroll" }}>
                                            <Table columns={columns} rowKey={(record: any) => record.patientId} dataSource={this.state.ref5} loading={loadingOth} bordered />
                                        </Col>
                                    </Row>                                     
                                </TabPane>
                                <TabPane tab={this.state.weekdays[day6]} key="6">
                                    <Row>
                                        <Col span={24} style={{ overflow: "scroll" }}>
                                            <Table columns={columns} rowKey={(record: any) => record.patientId} dataSource={this.state.ref6} loading={loadingOth} bordered />
                                        </Col>
                                    </Row>                                      
                                </TabPane>
                                <TabPane tab={this.state.weekdays[day7]} key="7">
                                    <Row>
                                        <Col span={24} style={{ overflow: "scroll" }}>
                                            <Table columns={columns} rowKey={(record: any) => record.patientId} dataSource={this.state.ref7} loading={loadingOth} bordered />
                                        </Col>
                                    </Row>                                      
                                </TabPane>
                            </Tabs>
                        </Col>
                    </Row>  

                </div>
            </div>
        )
    }
}

export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(Refill as any);
